function loadImage({
  src,
  width,
  quality,
  removeBackground,
  loading,
}: {
  src: string
  width?: number | 'auto'
  quality?: string
  removeBackground?: boolean
  loading?: string
}): string {
  const cloudinaryOrgId = 'abatable-com'

  const root = `https://res.cloudinary.com/${cloudinaryOrgId}/image/upload/`
  const params = ['f_auto', 'c_limit', `q_${quality ?? 'auto'}`]
  if (width) {
    params.push(`w_${width}`)
  }
  if (removeBackground) {
    params.push('t_remove-bg')
  }
  if (loading) {
    params.push(`t_${loading}`)
  }
  const paramsString = params.join(',') + '/'

  return `${root}${paramsString}${normalizeSrc(src)}`
}

function normalizeSrc(src: string): string {
  return src.startsWith('/') ? src.slice(1) : src
}

const cloudinaryService = {
  loadImage,
}

export { cloudinaryService }
